import { logoFileMapper, getLogoUrl } from '@interhyp/platform-logos';
import classNames from 'classnames';
import styles from "./ProviderLogo.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ProviderLogo = ({
  provider,
  variant = 'centered',
  className
}) => {
  const logo = logoFileMapper(provider);
  if (variant === 'cropped') {
    const style = {
      backgroundImage: `url(${getLogoUrl(logo[variant])})`
    };
    return /*#__PURE__*/_jsx("div", {
      style: style,
      className: classNames(styles.logo, className)
    });
  }
  return /*#__PURE__*/_jsx("img", {
    src: getLogoUrl(logo[variant]),
    alt: "providerLogo"
  });
};